export const conditionalBlockDocumentationMarkdown = `
When to Use
-----------

* Use the Multi-Conditional block when you want to route the flow based on multiple criteria and conditions.
* This block enables you to implement conditional "if/then" logic in your workflows, allowing you to alternate between different outcomes.
* You can create multiple branches (e.g., Path A, Path B) that execute different actions based on specified criteria.

How to Use
----------

### Basic Structure

1. **Select the Path Option Type**
   - Choose how conditions should be evaluated:
     - **Follow all matching conditions**: Evaluate every condition, even if one or more conditions are true. The flow will proceed down all paths where conditions match.
     - **Follow first matching condition only**: Evaluate conditions sequentially until one evaluates to true, then stop evaluating (remaining conditions will not be checked). The flow will proceed down only the first matching path.

2. **Add Condition(s)**
   - **Input Value**: Specify the data source to be assessed using the block template value format: \`{{blockName.data.field}}\`
   - **Choose Data Type and Operation**: Select from the available options:
     - **Boolean**: Check if a value is true or false
     - **String**: Compare strings with case-sensitive or case-insensitive matching
     - **Date**: Compare dates (before, after, equals, etc.)
     - **Date & Time**: Compare dates with time components
     - **Number**: Compare numbers, includes a range option to set minimum and maximum values, with the choice to include those limits
     - **Value**: Generic value comparison

3. **Add a Block Alias**
   - For each condition, provide a concise label to enhance readability from the block view. Aim to keep the label under 30 characters.

4. **Connect Paths**
   - Use the block nodes on the canvas to connect the paths for each condition and the Else path.
   - The Else path executes when no conditions match.

Examples
--------

### 1. Route Based on Patient Age
- Input Value: \`{{patientInfo.data.age}}\`
- Data Type: Number
- Operation: Range (18-65, inclusive)

This condition matches if age is between 18 and 65
- Connect this path to "Adult Care" workflow

### 2. Check Appointment Status
- Input Value: \`{{appointment.data.status}}\`
- Data Type: String
- Operation: Equals (case-insensitive)
- Comparison Value: "confirmed"

This condition matches if status is "confirmed" (case-insensitive)
- Connect this path to "Send Reminder" workflow

### 3. Multiple Conditions with First Match
- Condition 1:
  - Input Value: \`{{task.data.priority}}\`
  - Data Type: String
  - Operation: Equals
  - Comparison Value: "urgent"
- Condition 2:
  - Input Value: \`{{task.data.priority}}\`
  - Data Type: String
  - Operation: Equals
  - Comparison Value: "high"

Path Option: Follow first matching condition only
- First condition checks for "urgent", second checks for "high"
- Flow proceeds down first matching path only
- Connect these paths to "Urgent" or "High Priority" workflow
`;
